import { render, staticRenderFns } from "./DevicePaper.vue?vue&type=template&id=723f2deb&scoped=true&"
import script from "./DevicePaper.vue?vue&type=script&lang=js&"
export * from "./DevicePaper.vue?vue&type=script&lang=js&"
import style0 from "./DevicePaper.vue?vue&type=style&index=0&id=723f2deb&lang=scss&scoped=true&"
import style1 from "./DevicePaper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723f2deb",
  null
  
)

export default component.exports